import ListManagerComponent from './list-manager-component.js';


export default class ListManagerFilters extends ListManagerComponent
{

	constructor(options = {})
	{
		const defaults = {container:'filters'};

		let settings = {...defaults, ...options};

		super(settings);
		this.bindEvents();
	}

	bindEvents()
	{
		this.$el('container').find('select.filter').on('change', this.onChangeFilter.bind(this));
		this.$el('container').find('button.filter').on('click',  this.onChangeFilter.bind(this));
	}

	getValues()
	{
		const $filters = this.$el('container');
		if ($filters.length) {
			return $filters.serializeObject();
		}
		return {};
	}

	onChangeFilter(e)
	{
		e.preventDefault();

		this.manager.updateResults.call(this.manager);
	}

}